import { formatNumberToLocaleString } from '../number/formatNumberToLocaleString';

export const formatValue = (value: unknown) =>
  typeof value === 'number' ? formatNumberToLocaleString(value) : value;
